const FavIconLinks = () => {
  const iconColor = 'white'

  const additionalIconSizes = [96, 32, 16]
  const additionalAppleTouchIconSizes = [192, 180, 152, 144, 120, 114, 76, 72, 60, 57]

  return (
    <>
      <link
        rel="shortcut icon"
        href={`/favicon/dustin-symbol-${iconColor}-favicon-default.ico?v=2`}
      />
      <link
        rel="icon"
        sizes="16x16 32x32 64x64"
        href={`/favicon/dustin-symbol-${iconColor}-favicon-default.ico?v=2`}
      />
      {additionalIconSizes.map((iconSize, key) => (
        <link
          key={iconSize + key}
          rel="icon"
          type="image/png"
          sizes={`${iconSize}x${iconSize}`}
          href={`/favicon/dustin-symbol-${iconColor}-favicon-${iconSize}x${iconSize}.png?v=2`}
        />
      ))}
      <link
        rel="apple-touch-icon"
        href={`/favicon/dustin-symbol-${iconColor}-apple-57x57.png?v=2`}
      />
      {additionalAppleTouchIconSizes.map((iconSize, key) => (
        <link
          key={iconSize + key}
          rel="apple-touch-icon"
          sizes={`${iconSize}x${iconSize}`}
          href={`/favicon/dustin-symbol-${iconColor}-apple-${iconSize}x${iconSize}.png?v=2`}
        />
      ))}
    </>
  )
}

export default FavIconLinks
